module.exports = __webpack_public_path__ + "gn.6bab8b1e.svg";